import { render, staticRenderFns } from "./CustomerReceivesView.vue?vue&type=template&id=4b97051d"
import script from "./CustomerReceivesView.vue?vue&type=script&lang=js"
export * from "./CustomerReceivesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports